function PageContainer({ children }: { children: JSX.Element }) {
  return (
    <div className="max-w-screen-xl mx-auto">
      <div className="m-4">{children}</div>
    </div>
  );
}

export default PageContainer;
